import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { environment } from '@libs/environment';
import { CapacitorUtils } from '@libs/shared/capacitor/capacitor-utils';
import { EnvironmentType } from '@libs/models/environment.type';
import { NamesEnum } from '@libs/enums/names.enum';
import { ENVIRONMENT } from '@libs/shared/injections/window';

@Component({
  selector: 'app-auth-agreement',
  templateUrl: `./templates/${environment.group}/page.html`,
  styleUrls: [`./templates/${environment.group}/style.sass`],
})
export class AuthAgreementComponent implements OnInit {
  @Input()
  public labelClasses: string = '';
  @Input()
  public imgSize: string = '24px';
  public form: FormGroup;
  //TODO: carefully! used on all sites!
  public accept: { name: string; link?: string }[];
  @Input()
  private formGroupName: string;

  constructor(
    private rootFormGroup: FormGroupDirective,
    @Inject(ENVIRONMENT) private environment: EnvironmentType,
  ) {}

  public ngOnInit(): void {
    const path: string = this.environment?.publicDocumentsUrl;
    const first: string = `${path}Правила_надання_коштів_у_кредит.pdf`;
    const second: string = `${path}Згода_на_обробку_передачу_і_отримання_персональних_даних_клієнтів_ТОВ_СТАР_ФАЙНЕНС_ГРУП.pdf`;
    this.accept = [
      { name: 'ACCEPT.TEXT_1' },
      { name: 'ACCEPT.TEXT_2', link: first },
      { name: 'ACCEPT.TEXT_3' },
      { name: 'ACCEPT.TEXT_4', link: second },
      { name: this.environment.group === NamesEnum.AVANS ? '' : 'ACCEPT.TEXT_5' },
    ];
    this.form = this.rootFormGroup.control.get(this.formGroupName) as FormGroup;
  }

  public async download(link: string): Promise<void> {
    await CapacitorUtils.downloadAndOpenFile(link, 'document');
  }
}
